import {
	GET_PRE_CALCULATED_DATA,
	GET_PRE_CALCULATED_DATA_FAIL,
	GET_PRE_CALCULATED_DATA_SUCCESS,
	GET_PRE_CALCULATED_DATA_RESET,
} from '../actions/getPreCalculatedDataAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const getPreCalculatedDataReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_PRE_CALCULATED_DATA:
			return {
				...state,
				apiState: 'loading',
			};
		case GET_PRE_CALCULATED_DATA_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message
					? action.response.message
					: 'success',
			};
		case GET_PRE_CALCULATED_DATA_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors,
				message: action.response.message
					? action.response.message
					: 'error',
			};
		case GET_PRE_CALCULATED_DATA_RESET:
			return initialState;
		default:
			return state;
	}
};

export default getPreCalculatedDataReducer;
